import * as types from './actionType'
import { sortMyArray } from '../../util/Merge'
import * as orderMapper from '../../mappers/OrderMapper'
import {
  checkIsEnabledRow,
  getPegasusID,
  getSampleIDPrefix,
} from '../../util/CommonUtils'
import { getDisplayImage } from '../../util/CommonUtils'
import { DATE_FORMAT, convertTableDateFormat } from '../../util/CommonUtils'
import { findIndex, cloneDeep, filter, isEmpty, sortBy } from 'lodash'
import { SAMPLE } from 'enums/Tabs'

export const valueToCheckAgainst = {
  keyToCheckAgainst: 'isShippedEntity',
  value: false,
}

export const initialState = {
  alertIsVisible: false,
  alertMessage: '',
  checkBoxEnabled: true,
  clickableColumn: ['imageUrl', 'description'],
  columnData: [
    {
      id: 'pegasusId',
      numeric: false,
      disablePadding: true,
      label: 'Pegasus ID',
      textAlign: 'right',
    },
    {
      id: 'imageUrl',
      numeric: false,
      disablePadding: true,
      label: 'Image',
      textAlign: 'right',
    },
    {
      id: 'tcin',
      numeric: true,
      disablePadding: false,
      label: 'TCIN',
      align: 'center',
    },
    {
      id: 'dpci',
      numeric: false,
      disablePadding: false,
      label: 'DPCI',
      textAlign: 'right',
    },
    {
      id: 'subClassName',
      numeric: false,
      disablePadding: false,
      label: 'Sub Class',
      textAlign: 'right',
    },
    {
      id: 'subClassId',
      numeric: false,
      disablePadding: false,
      label: 'Sub Class ID',
      textAlign: 'right',
    },
    {
      id: 'description',
      numeric: false,
      disablePadding: true,
      label: 'Description',
      textAlign: 'right',
    },
    {
      id: 'location',
      numeric: false,
      disablePadding: true,
      label: 'Current Location',
      textAlign: 'right',
    },
    {
      id: 'currentProjects',
      numeric: false,
      disablePadding: true,
      label: 'Current Projects',
      textAlign: 'right',
    },
    {
      id: 'mostRecentShipment',
      numeric: true,
      disablePadding: true,
      label: 'Most Recent Shipment Id',
      textAlign: 'right',
    },
    {
      id: 'shipmentSampleStatus',
      numeric: false,
      disablePadding: true,
      label: 'Current Status in Shipment',
      textAlign: 'right',
    },
    {
      id: 'addedBy',
      numeric: false,
      disablePadding: true,
      label: 'Added By',
      textAlign: 'right',
    },
    {
      id: 'addedToShipmentDate',
      numeric: false,
      disablePadding: true,
      label: 'Added to Shipment',
      textAlign: 'right',
    },
    {
      id: 'shippedDate',
      numeric: false,
      disablePadding: true,
      label: 'Date Shipped',
      textAlign: 'right',
    },
  ],
  propsColumnData: [
    {
      id: 'propId',
      label: 'Filemaker ID',
    },
    { id: 'shipmentBundleCount', label: '#Bundle Shipped' },
  ],
  unavailableSampleLocStatusData: [
    {
      id: 'pegasusId',
      numeric: false,
      disablePadding: true,
      label: 'Pegasus ID',
      textAlign: 'right',
    },
    {
      id: 'imageUrl',
      numeric: false,
      disablePadding: true,
      label: 'Image',
      textAlign: 'right',
    },
    {
      id: 'description',
      numeric: false,
      disablePadding: true,
      label: 'Description',
      textAlign: 'right',
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: true,
      label: 'Current Status',
      textAlign: 'right',
    },
    {
      id: 'location',
      numeric: false,
      disablePadding: true,
      label: 'Current Location',
      textAlign: 'right',
    },
  ],
  unavailableSampleColumnData: [
    {
      id: 'pegasusId',
      numeric: false,
      disablePadding: true,
      label: 'Pegasus ID',
      textAlign: 'right',
    },
    {
      id: 'imageUrl',
      numeric: false,
      disablePadding: true,
      label: 'Image',
      textAlign: 'right',
    },
    {
      id: 'description',
      numeric: false,
      disablePadding: true,
      label: 'Description',
      textAlign: 'right',
    },
    {
      id: 'shipmentNumber',
      numeric: false,
      disablePadding: true,
      label: 'Shipment #',
      textAlign: 'right',
    },
    // {
    //   id: 'shipTo',
    //   numeric: false,
    //   disablePadding: true,
    //   label: 'Ship to location',
    //   textAlign: 'right',
    // },
    {
      id: 'createdBy',
      numeric: false,
      disablePadding: true,
      label: 'Shipment Creator',
      textAlign: 'right',
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: true,
      label: 'Current Status',
      textAlign: 'right',
    },
  ],
  data: [],
  goNextFlag: false,
  isVisible: false,
  unknownPegasusIds: [],
  item: {},
  numSelected: 0,
  onCheckBoxChange: () => {},
  onCheckBoxHeaderChange: () => {},
  onClick: () => {},
  order: 'asc',
  orderBy: 'pegasusIds',
  shipmentId: 0,
  shipmentStatus: '',
  response: false,
  page: 0,
  shipmentData: {},
  projectNames: [],
  shipToLocations: [],
  shipFromLocations: [],
  popupIsVisible: false,
  rowCount: 20,
  rowsPerPage: 20,
  searchField: '',
  selectedData: [],
  addSamplesRequestFailure: false,
  addSamplesRequestPending: false,
  shipmentCreateRequestFailure: false,
  shipmentCreateRequestPending: false,
  shipmentDeleteRequestFailure: false,
  shipmentDeleteRequestPending: false,
  shipmentUpdateRequestFailure: false,
  shipmentUpdateRequestPending: false,
  shipmentGetRequestFailure: false,
  shipmentGetRequestPending: false,
  shipmentGetRequestSuccess: false,
  removeSampleFailure: false,
  removeSamplePending: false,
  fetchLocationRequestFailure: false,
  fetchLocationRequestPending: false,
  addSamplesResponse: {},
  unavailableSamples: [],
  unavailableSamplesRequestPending: false,
  unavailableSamplesRequestFailure: false,
  unavailableSamplePopUpIsVisible: false,
}

function getProjectNames(projects) {
  const projectDetails = projects.map(function (obj) {
    return {
      projectDetail: obj.name.concat(
        ' - ',
        convertTableDateFormat(obj.shootStartDate, DATE_FORMAT),
        ' - ',
        convertTableDateFormat(obj.shootEndDate, DATE_FORMAT)
      ),
    }
  })
  return projectDetails.map((x) => x.projectDetail).join(', ')
}

export default function search(state = initialState, action = {}) {
  switch (action.type) {
    case types.SHOOT_SHIP_SET_CHECKBOX: {
      const {
        payload: { selected: payloadSelectedData = {} },
      } = action
      const { selectedData: overlaySelectedData = [] } = state
      const selectedIndex = overlaySelectedData.find(
        (obj) => obj.pegasusId === payloadSelectedData.pegasusId
      )
      let newSelected = []
      if (selectedIndex === -1 || !selectedIndex) {
        newSelected = newSelected.concat(
          overlaySelectedData,
          payloadSelectedData
        )
      } else {
        newSelected = overlaySelectedData.filter(
          (item) => item.pegasusId !== payloadSelectedData.pegasusId
        )
      }

      return Object.assign({}, state, {
        numSelected: newSelected.length,
        selectedData: newSelected,
      })
    }
    case types.SHOOT_SHIP_SET_CHECKBOX_HEADER: {
      const { selectedData = [] } = state
      const {
        payload: { selected: selectedItems = {} },
      } = action
      let selectedIds = selectedItems.filter((item) =>
        checkIsEnabledRow(valueToCheckAgainst, item)
      )
      const selectedDiffCount = selectedData.filter(
        (i) =>
          findIndex(selectedIds, function (obj) {
            return obj.pegasusId === i.pegasusId
          }) !== -1
      ).length

      var newDataObj = [].concat.apply(selectedData, selectedIds)

      let newSelected = []
      if (selectedDiffCount === 0) {
        newSelected = newDataObj
      } else {
        newSelected = selectedData.filter(
          (i) =>
            findIndex(selectedIds, function (obj) {
              return obj.pegasusId === i.pegasusId
            }) === -1
        )
      }

      return Object.assign({}, state, {
        ...state,
        selectedData: newSelected,
        numSelected: newSelected.length,
      })
    }
    case types.SHOOT_SHIP_CREATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        ...state,
        shipmentId: action.payload.data.shipmentId,
        goNextFlag: true,
        shipmentStatus: action.payload.data.status,
      })

    case types.SHOOT_SHIP_CREATE_REQUEST_PENDING:
      return Object.assign({}, state, {
        shipmentCreateRequestPending: action.payload.pending,
      })

    case types.SHOOT_SHIP_CREATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        shipmentCreateRequestFailure: true,
      })

    case types.SHOOT_SHIP_GET_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        shipmentData: action.payload.shipmentData,
        shipmentId: action.payload.shipmentData.shipmentId,
        shipmentStatus: action.payload.shipmentData.status,
        shipmentGetRequestSuccess: true,
      })

    case types.SHOOT_SHIP_GET_REQUEST_PENDING:
      return Object.assign({}, state, {
        shipmentGetRequestPending: action.payload.pending,
        shipmentGetRequestSuccess: false,
      })

    case types.SHOOT_SHIP_GET_REQUEST_FAILURE:
      return Object.assign({}, state, {
        shipmentGetRequestFailure: true,
        shipmentGetRequestSuccess: false,
      })

    case types.SHOOT_SHIP_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        ...state,
        goNextFlag: false,
        shipmentStatus: '',
      })

    case types.SHOOT_SHIP_DELETE_REQUEST_PENDING:
      return Object.assign({}, state, {
        shipmentDeleteRequestPending: action.payload.pending,
      })

    case types.SHOOT_SHIP_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        shipmentDeleteRequestFailure: true,
        goNextFlag: false,
      })
    case types.CLEAR_STATE_DATA:
      return Object.assign({}, state, {
        data: [],
      })

    case types.ADD_SAMPLES_REQUEST_SUCCESS: {
      const projectName = []
      const actionPayloadData = action.payload.data || []
      const finalDataArr = sortMyArray(actionPayloadData, 'updateTs') || []
      const payloadData = finalDataArr.map((item) => ({
        ...item,
        imagePopupUrl: item.imageUrl,
        imageUrl:
          item.imageUrl !== undefined &&
          item.imageUrl !== null &&
          item.imageUrl !== ''
            ? getDisplayImage(item.imageUrl) // TODO PROPS ?
            : 'Image Not Found',
        currentProjects:
          item.projects !== null ? getProjectNames(item.projects) : null,
        projectsName:
          item.projects !== undefined &&
          item.projects !== null &&
          item.projects !== ''
            ? item.projects.map(function (obj) {
                return projectName.push({
                  projectId: obj.id,
                  projectName: obj.name,
                  projectChannel: obj.channel,
                })
              })
            : null,
      }))

      const uniqueProject = Array.from(
        new Set(state.projectNames.concat(projectName))
      ).reduce((acc, current) => {
        const x = acc.find((item) => item.projectId === current.projectId)
        if (!x) {
          return acc.concat([current])
        } else {
          return acc
        }
      }, [])

      const nonBundleData = filter(payloadData, function (o) {
        return !o.isBundle
      })
      const bundleData = filter(payloadData, function (o) {
        return o.isBundle
      })
      const updatedData = isEmpty(nonBundleData)
        ? state.data
        : [...nonBundleData, ...state.data]
      const addSamplesResponse = action.payload.isFlyout ? payloadData : {}

      const sortedData = sortBy(
        [...bundleData, ...updatedData],
        'addedToShipmentDate'
      )

      return Object.assign({}, state, {
        ...state,
        data: sortedData,
        projectNames: uniqueProject,
        addSamplesResponse,
      })
    }

    case types.ADD_SAMPLES_REQUEST_PENDING:
      return Object.assign({}, state, {
        addSamplesRequestPending: action.payload.pending,
        addSamplesResponse: {},
      })

    case types.ADD_SAMPLES_REQUEST_FAILURE:
      return Object.assign({}, state, {
        addSamplesRequestFailure: true,
        addSamplesResponse: {},
      })

    case types.UNAVAILABLE_SAMPLES_SUCCESS: {
      const {
        payload: { data: payloadData = [] },
      } = action
      const unavailableSamples = payloadData.map((item) => {
        const { resource: itemResource = {} } = item
        const { pegasusId: itemPegasusId = '', type = SAMPLE } = itemResource
        return {
          ...item,
          resource: Object.assign({}, itemResource, {
            pegasusId: getSampleIDPrefix(itemPegasusId, type),
          }),
        }
      })
      return Object.assign({}, state, {
        ...state,
        unavailableSamples: unavailableSamples,
        unavailableSamplePopUpIsVisible: true,
      })
    }

    case types.UNAVAILABLE_SAMPLES_PENDING:
      return Object.assign({}, state, {
        unavailableSamplesRequestPending: action.payload.pending,
      })

    case types.UNAVAILABLE_SAMPLES_FAILURE:
      return Object.assign({}, state, {
        unavailableSamplesRequestFailure: true,
      })

    case types.SHOOT_SHIP_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        ...state,
        goNextFlag: false,
        shipmentStatus: '',
      })

    case types.SHOOT_SHIP_UPDATE_REQUEST_PENDING:
      return Object.assign({}, state, {
        shipmentUpdateRequestPending: action.payload.pending,
      })

    case types.SHOOT_SHIP_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        shipmentUpdateRequestFailure: true,
      })

    case types.REMOVE_SAMPLE_REQUEST_SUCCESS: {
      const idSet = new Set(action.payload.data.map((item) => item.pegasusId))
      return Object.assign({}, state, {
        ...state,
        data: state.data.filter((sample) => {
          let shouldFilter =
            sample.isShippedEntity || !idSet.has(sample.pegasusId)
          return shouldFilter
        }),
        selectedData: [],
        numSelected: 0,
      })
    }

    case types.REMOVE_SAMPLE_REQUEST_PENDING:
      return Object.assign({}, state, {
        removeSamplePending: action.payload.pending,
      })

    case types.REMOVE_SAMPLE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        removeSampleFailure: true,
      })

    case types.FETCH_SHIP_FROM_LOCATION_REQUEST_SUCCESS: {
      const shipFromLocations = action.payload.data.data.buildings.sort(
        (a, b) => {
          const aBuilding = a.building?.toLowerCase()
          const bBuilding = b.building?.toLowerCase()
          if (aBuilding < bBuilding) {
            //sort string ascending
            return -1
          }
          if (aBuilding > bBuilding) {
            return 1
          }
          return 0 //default return value (no sorting)
        }
      )
      return Object.assign({}, state, {
        ...state,
        shipFromLocations,
      })
    }

    case types.FETCH_SHIP_TO_LOCATION_REQUEST_SUCCESS: {
      return Object.assign({}, state, {
        ...state,
        shipToLocations: action.payload.data.data.buildings,
      })
    }

    case types.FETCH_SHIP_LOCATION_REQUEST_PENDING:
      return Object.assign({}, state, {
        fetchLocationRequestPending: action.payload.pending,
      })

    case types.FETCH_SHIP_LOCATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        fetchLocationRequestFailure: true,
      })

    case types.SHOOT_SAMPLE_SET_PAGE: {
      return Object.assign({}, state, {
        page: action.payload.page,
      })
    }
    case types.SHOOT_SAMPLE_SET_ROWS_PER_PAGE: {
      return Object.assign({}, state, {
        rowsPerPage: action.payload.rowsPerPage,
      })
    }
    case types.SHOOT_SAMPLE_CLEAR_DATA:
      return Object.assign({}, state, {
        ...state,
        unknownPegasusIds: [],
        searchField: '',
      })
    case types.SHOOT_SAMPLE_SET_UNKNOWN_DATA:
      return Object.assign({}, state, {
        ...state,
        unknownPegasusIds: orderMapper.sampleIdsBuilder(action.payload.data),
      })
    case types.SHOW_SHOOT_SHIP_PAGE_ALERT: {
      const newState = {
        ...state,
        alertIsVisible: true,
        alertMessage: action.payload.message,
        response: true,
      }
      return newState
    }
    case types.CLOSE_SHOOT_SHIP_PAGE_ALERT: {
      const newState = {
        ...state,
        alertIsVisible: false,
      }
      return newState
    }
    case types.SHOW_SHOOT_SHIP_POPUP:
      return Object.assign({}, state, {
        ...state,
        popupIsVisible: true,
        item: action.payload.item,
      })

    case types.CLOSE_SHOOT_SHIP_POPUP:
      return Object.assign({}, state, {
        ...state,
        popupIsVisible: false,
      })

    case types.CLOSE_UNAVAILABLE_SAMPLES_POPUP:
      return Object.assign({}, state, {
        ...state,
        unavailableSamplePopUpIsVisible: false,
        unavailableSamples: [],
      })

    case types.RESET_NEW_SHIPMENT_STATE:
      return Object.assign({}, initialState)

    case types.SET_REDIRECT_TO_NEW_SHIPMENT:
      return Object.assign({}, state, {
        ...state,
        goNextFlag: action.payload.goNextFlag,
      })
    case types.SHOOT_SHIP_CALL_EDIT_FIELDS_API: {
      const { data: stateData = [] } = state
      const {
        payload: { data: payloadData, sample_id },
      } = action
      const newDataObj = (stateData || []).map((obj) => {
        if (obj.pegasusId.indexOf(sample_id) !== -1) {
          obj = Object.assign({}, obj, payloadData)
        }
        return obj
      })
      return Object.assign({}, state, {
        ...state,
        data: newDataObj,
      })
    }
    case types.UPDATE_BUNDLED_QUANTITY: {
      const {
        payload: { pegasusId, updatedQuantity },
      } = action
      const { data } = state
      const dataList = cloneDeep(data)
      const updatedData = dataList.reduce((acc, data) => {
        if (
          !data.isShippedEntity &&
          getPegasusID(data.pegasusId) === pegasusId?.toString()
        ) {
          data.shipmentBundleCount = Number(updatedQuantity)
        }
        acc.push(data)
        return acc
      }, [])
      return Object.assign({}, state, {
        ...state,
        data: updatedData,
      })
    }
    default:
      return state
  }
}
